/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2020. All Rights Reserved.
 #*
 #*===================================================================
 */

import { createAction, props } from '@ngrx/store';

import { PriceConfigExtended } from '@core/models/price-config.model';
import { PriceConfigPriceType } from '@core/models';

export const load = createAction('[ClientDetails:Configurations] Load', props<{ clientId: number }>());
export const loadSuccess = createAction(
  '[ClientDetails:Configurations] Load Success',
  props<{ configurations: PriceConfigExtended[] }>()
);
export const loadFailure = createAction(
  '[ClientDetails:Configurations] Load Failure',
  props<{ errorMessage: string }>()
);

export const updatePriceType = createAction(
  '[Admin Console:Configurations] Update Price Config Price Type',
  props<{ priceType: Partial<PriceConfigPriceType>; updatedBy: string }>()
);
export const updatePriceTypeSuccess = createAction(
  '[Admin Console:Configurations] Update Price Config Price Type Success',
  props<{ priceType: PriceConfigPriceType; updatedBy: string; oldPriceTypeId: number | null }>()
);
export const updatePriceTypeFailure = createAction(
  '[Admin Console:Configurations] Update Price Config Price Type Failure',
  props<{ errorMessage: string }>()
);

export const updateSelectedPriceTypes = createAction(
  '[Admin Console:Configurations] Update Price Selected Price Types',
  props<{ priceTypes: Partial<PriceConfigPriceType[]>; updatedBy: string }>()
);
export const updateSelectedPriceTypesSucccess = createAction(
  '[Admin Console:Configurations] Update Price Config Selected Price Types Success',
  props<{ priceTypes: PriceConfigPriceType[]; updatedBy: string }>()
);
export const updateSelectedPriceTypesFailure = createAction(
  '[Admin Console:Configurations] Update Price Config Selected Price Types Failure',
  props<{ errorMessage: string }>()
);
